/**
*
* Breadcrumbs
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { last } from 'lodash-es';
import Icon2 from 'components/media/Icon2/index.js';
import IntlString from 'components/media/IntlString/index.jsx';

function Breadcrumbs(props) {
  const { parts, className } = props;
  if (!parts || parts.length === 0) {
    return null;
  }
  return (
    <h2 className={className}>
      { parts.slice(0, -1).map((part) => (
        <React.Fragment key={part.label}>
          <Link to={part.href}><IntlString message={part.label} /></Link>
          <Icon2 className="ss-navigateright p-0 mx-3 lower-1 text-muted" />
        </React.Fragment>
      ))}
      <IntlString message={last(parts).label} />
    </h2>
  );
}

Breadcrumbs.propTypes = {
  parts: PropTypes.array,
  className: PropTypes.string,
};

export default Breadcrumbs;
